import { render, staticRenderFns } from "./NewPageModal.vue?vue&type=template&id=c959a514&scoped=true"
import script from "./NewPageModal.vue?vue&type=script&lang=js"
export * from "./NewPageModal.vue?vue&type=script&lang=js"
import style0 from "./NewPageModal.vue?vue&type=style&index=0&id=c959a514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c959a514",
  null
  
)

export default component.exports